import React from 'react'
import TextField from '@mui/material/TextField'
import { FormInputFieldProps } from '../propsTypes'

const FormInputField = ({
  placeholder,
  value,
  onChange,
  error,
  helperText,
  fullWidth,
}: FormInputFieldProps) => {
  return (
    <TextField
      required
      id="outlined-basic"
      placeholder={placeholder}
      variant="outlined"
      helperText={helperText}
      value={value}
      onChange={onChange}
      fullWidth={fullWidth ?? true}
      error={error}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderColor: 'transparent',
          color: '#fff',
          background: 'rgba(255, 255, 255, 0.05)',
          fontFamily: 'Space Grotesk, sans-serif',
        },
        '& .MuiFormHelperText-root': {
          color: '#fff',

          '&.Mui-error': {
            color: '#d32f2f',
          },
        },
      }}
    />
  )
}

export default FormInputField
